module.exports = __webpack_public_path__ + "static/modern_software_delivery-429589f9242f58418c97737433828411.jpg";